import { isString, logger } from '@cutwise/utils';

import config from '@/config';

export function addPrefixToHost(prefix: string) {
  let hostname = location.hostname;

  // script below allows to set host from environment variable,
  // helpful for local development
  try {
    if (isString(config.API_HOST) && config.API_HOST.length > 0) {
      const baseSplit = config.API_HOST.split('//'); // check if variable set with protocol, like "https://staging.cutwise.com"

      hostname = new URL(`https://${baseSplit[baseSplit.length - 1]}`).hostname;
    }
  } catch (e) {
    logger.error(e);
  }

  let url = '';

  /*
   * Below we need to check if site opened on subdomain (e.g. develop.cutwise.com, staging.cutwise.com),
   * if Yes, prefix should be like "api-*.cutwise.com", if No - "api.cutwise.com"
   *
   * This is because we can't have domain with 4 levels because of certificates
   *
   * Examples
   *   - cutwise.com -> api.cutwise.com
   *   - develop.cutwise.com -> api-develop.cutwise.com
   *   - staging.cutwise.com -> api-staging.cutwise.com
   * */
  const subdomainSearch = /\w+\.cutwise\.(com|local|link)/gi.exec(hostname);
  const subdomain = subdomainSearch?.[0] ?? null;

  url = location.protocol;
  url += `//${subdomain ? `${prefix}-${subdomain}` : `${prefix}.${hostname}`}`;

  return url;
}
